import { module } from 'angular';

import widgetWrapperComponent from './widget-wrapper/widget-wrapper.component';

// gauge
import gaugeChartSettings from './widgets/gauge/settings/gauge-chart-settings.component';
import gaugeChartWidget from './widgets/gauge/gauge-chart-widget.component';

// pie
import pieChartWidget from './widgets/pie/pie-chart-widget.component';
import pieChartSettings from './widgets/pie/settings/pie-chart-settings.component';

// table
import ktableWidget from './widgets/ktable/ktable-widget.component';
import ktableSettings from './widgets/ktable/settings/ktable-settings.component';

// table
import progressWidget from './widgets/progress/progress-widget.component';
import progressSettings from './widgets/progress/settings/progress-settings.component';

export default module('app.dashboard', [])
	.component('widgetWrapper', widgetWrapperComponent)

	// Gauge chart
	.component('gaugeChartSettings', gaugeChartSettings)
	.component('gaugeChartWidget', gaugeChartWidget)
	// Pie chart
	.component('pieChartWidget', pieChartWidget)
	.component('pieChartSettings', pieChartSettings)
	// Ktable widget
	.component('ktableWidget', ktableWidget)
	.component('ktableSettings', ktableSettings)
	// Progress widget
	.component('progressWidget', progressWidget)
	.component('progressSettings', progressSettings)

	.name;
